/**
 * Main Binshare web app URL.
 *
 * The landing page is hosted at binshare.co.uk (marketing). The actual
 * Binshare web app — where customers post jobs, list items to reuse and
 * carriers bid — lives at the URL below.
 *
 * Hardcoded so no production env var is required.
 */
export const MAIN_APP_URL = "https://app.binshare.co.uk";

/**
 * Native store listings. When a URL is present the corresponding
 * `AppStoreBadges` component renders a live, clickable badge; when it's
 * left as `null` the badge renders in "Coming Soon" state.
 *
 * Fill these in as each store approves the listing.
 */
export const STORE_URLS = {
  appStore: "https://apps.apple.com/gb/app/binshare/id6795630167",
  googlePlay:
    "https://play.google.com/store/apps/details?id=uk.co.binshare.marketplace",
};
